export enum AssignmentType {
  Pending = 'PENDING',
  Full = 'FULL',
  All = 'ALL',
}
